<template>
  <main class="success">
    <section class="wrapper section">
      <div class="success-content">
        <font-awesome-icon class="error-icon" :icon="'exclamation-triangle'" />
        <h1 class="success-title">{{ title }}</h1>

        <p class="success-text">{{ message }}</p>
      </div>
    </section>
  </main>
</template>

<script>
import Storage from '../../services/storage';

export default {
  name: 'GenericError',
  data() {
    return {
      title: null,
      message: null
    };
  },
  mounted() {
    this.title = Storage.get('error_title', 'Erro');
    this.message = Storage.get('error_message');
    Storage.clear();
  }
};
</script>
